import { types as ActionTypes } from './Dashboard.actions';
import { types as AuthActionTypes } from '/b2b/authentication/state/Auth.actions';
import { combineReducers } from 'redux';
import { genericReducer } from '../../common/helpers/ReduxHelpers';
import reduceReducers from 'reduce-reducers';

export const initialState = {
    preferences: {
        selectedDomain: null,
        todos: {},
    },
};

export default reduceReducers(
    initialState,
    combineReducers({
        preferences: genericReducer(initialState.preferences, {
            [ActionTypes.updateSelectedDomain]: (state, domain) => ({
                ...state,
                selectedDomain: domain,
            }),
            [ActionTypes.updateTodoPreferences]: (state, todos) => ({
                ...state,
                todos: {
                    ...state.todos,
                    ...todos,
                },
            }),
        }),
    }),
    genericReducer(initialState, {
        [AuthActionTypes.logout]: () => initialState,
    })
);
